import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  getSideBarfilesActions,
  SetTheOndutyActions,
  SetTheOndutynDelete,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setDropDownRenders,
  setTheOndutyrequestRange1,
  setTheOndutyRequestRange2,
  setTheOndutyRequestZone,
  setTheOndutyRequestState,
  setTheOndutyRequestRegion,
  SettheOndutyRequestStatusState,
  setTheOndutyDesignation
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import OnDutyEdit from "./OnDutyEdit";
import Delete from "../../AppComponent/Popup/Delete";
import Select from "react-select";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ThumbsImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-13.svg";
import useDebouncedEffect from 'use-debounced-effect';

const Onduty = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setData] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [search, setsearch] = useState("");
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  // var today = new Date();
  // var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  // var it = convert(today);
  // var gt = convert(priorDate);
  // // console.log(it, gt);
  // const [range, setrange] = useState(

  //   // [gt, it]
  // []

  // );

  var it = convert(state.StateManagementOverallCall.OndutyReuquestRange1);
  var gt = convert(state.StateManagementOverallCall.OndutyReuquestRange2);
  const [range, setrange] = useState(
    state.StateManagementOverallCall.OndutyReuquestRange1 == ""
      ? // [it, gt]
        []
      : [it, gt]
  );

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },

    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    console.log(value, "vlues");

    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const [filterForWhite, setFilters] = useState({ white_collar: 
    state.StateManagementOverallCall.OndutyEmployeedesignation?.value == "" ||
    state.StateManagementOverallCall.OndutyEmployeedesignation?.value =="0" ?
    "":
    state.StateManagementOverallCall.OndutyEmployeedesignation?.value == 1 ?
    true:
    false
   });
  const HandleEMprole = (e) => {
    if (e != null) {
       dispatch(setTheOndutyDesignation(e))
      setdtPageindex(1);
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(setTheOndutyDesignation({value:"",label:"ALL"}))

      }
    }
  };

  const FileterState = {
    status: state.StateManagementOverallCall.OndtyStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);

  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.OndutyrequestRegion
  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.OndutyrequestZone
  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setDatas] = useState({
    // zone: state.ClientBranchIDs.ZoneName.value,
    // state: state.ClientBranchIDs.StateName.value,
    // region: state.ClientBranchIDs.RegionName.value,
    state: state.StateManagementOverallCall.OndutyrequestState?.value,
    region: state.StateManagementOverallCall.OndutyrequestRegion?.value,
    zone: state.StateManagementOverallCall.OndutyrequestZone?.value,
  });
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "ALL" }
    state.StateManagementOverallCall.OndutyrequestState,
    // state.ClientBranchIDs.StateName,
  ]);
  const UserObjectData = useSelector((state) => state.users.UserData);

  const options = [
    { value:"" , label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];
    const [place, SetPlace] = useState("ALL");
  const [sel, setSelected] = useState();

  //--------Place---Holder----dispatch======
  useEffect(() => {
    dispatch(setDropDownRenders(""));

    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options));
      SetPlace("All");
    }

    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
    }
  }, [state.NumberCounts.namerednder]);
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
        search: search,
        page_size: 20,
        page: dtpageindex,
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
        // month: Datestate.month,
        // year: Datestate.year,
        from_date: range[0],

        to_date: range[1],
      };
      dispatch(SetTheOndutyActions(payload));
    }
  }, [selectVal, data, filterForWhite, range, dtpageindex ,search ]);
  useEffect(() => {
    setData(state.OndutyCalls.OnDutyDatas);
  }, [state.OndutyCalls.OnDutyDatas]);



  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);



  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);



  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheOndutyrequestRange1(range[0]));
      dispatch(setTheOndutyRequestRange2(range[1]));
    }
  }, [range]);

  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      dispatch(setTheOndutyRequestRegion(selectedVal));
      dispatch(setTheOndutyRequestZone({ value: "", label: "ALL" }));

      setDatas({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheOndutyRequestRegion({ value: "", label: "ALL" }));
      dispatch(setTheOndutyRequestZone({ value: "", label: "ALL" }));

      setDatas({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      dispatch(setTheOndutyRequestZone(selectedVal));

      setDatas({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setDatas({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheOndutyRequestZone({ value: "", label: "ALL" }));
    }
  };
  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      // console.log(selectedVal, "asfad");
      dispatch(setTheOndutyRequestState(selectedVal));
      dispatch(setTheOndutyRequestRegion({ value: "", label: "ALL" }));
      dispatch(setTheOndutyRequestZone({ value: "", label: "ALL" }));

      setDatas({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheOndutyRequestState({ value: "", label: "ALL" }));
      dispatch(setTheOndutyRequestRegion({ value: "", label: "ALL" }));
      dispatch(setTheOndutyRequestZone({ value: "", label: "ALL" }));

      setDatas({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);


  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });

        }
    },
    500,
    [SearchDebounance]
);


  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

  const column = [
    {
      Header: filterForWhite.white_collar ? "User Name" : "Employee Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.user_id.first_name}</span>
          </>
        );
      },
    },
    {
      Header: " Date",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.for_date ? (
              <span>{row.row.original.for_date}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Start Time",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.from_time ? (
              <span>{row.row.original.from_time}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "End Time",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.to_time ? (
              <span>{row.row.original.to_time}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Purpose",
      accessor: "",
      Cell: (row) => {
        const originalString = row.row.original.purpose;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.purpose ? (
              <span>{capitalizedString}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Branch",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.client_id != undefined ? (
              <span>{row.row.original.client_id.client_name}</span>
            ) : (
              <span>{"----"}</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Place",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.place_id != undefined ? (
              <span>{row.row.original.place_id.address}</span>
            ) : (
              <span>{"----"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >


              {row.row.original.status.toLowerCase() === "approved" ? (
                <button
                  className=" btn Status"
                  component="span"
                  style={{ cursor: "not-allowed" }}
                >
                  <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                    <span className="ActionsList"> Approved </span>
                  </span>
                </button>
              ) : (
                <>
                  {row.row.original.status.toLowerCase() === "decline" ? (
                    <button
                      className=" btn Status"
                      component="span"
                      style={{ cursor: "not-allowed" }}
                      onClick={(e) => {
                        if (
                          !row.row.original.status.toLowerCase() == "approved"
                        ) {
                          setEmployeePop(true);
                          setEmployeeIDs(row.row.original.id);
                        }
                      }}
                    >
                      <span className="OuterActionSpan">
                      <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                        <span className="ActionsList"> Decline </span>
                      </span>
                    </button>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() === "pending" ? (
                        <button
                          className=" btn Status"
                          component="span"
                          onClick={(e) => {
                            setEmployeePop(true);
                            setEmployeeIDs(row.row.original.id);
                          }}
                        >
                          <span className="OuterActionSpan">
                          <span  className="EditImages">
                           <img src={EditImages}/>
                          </span>
                            <span className="ActionsList"> Approve </span>
                          </span>
                        </button>
                      ) : null}
                    </>
                  )}
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];

  const HandleSubmits = () => {
    const payload = {
      DeleteID: DeleteID,
      currentPage: currentPage,
      data: data,
      selectVal: selectVal,
      white_collar: filterForWhite.white_collar,
      // month: Datestate.month,
      // year: Datestate.year,
      from_date: range[0],

      to_date: range[1],
    };
    dispatch(SetTheOndutynDelete(payload, setDeletePopup(false)));
  };

  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
      setdtPageindex(1);
      dispatch(SettheOndutyRequestStatusState({value:"", label:"All"}))

    }
  };
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setSelected(sel);
    SetStates(true);
    setdtPageindex(1);
    dispatch(SettheOndutyRequestStatusState(SelectedValues))

    //  console.log(SelectedValues, "SelectedValues");
     
    if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

   

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const openMe = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '631.344px', 'important');
      rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
  
   const CloseDateRange = ()=>{
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
   }
  
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>On-Duty Request</h3>
           
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "90",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              onInputChange={handleInputRegion}
              value={multiselect1}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Region"
              //     : "search"
              // }
            />
          </div>
          <div
            className="col-sm-2"
            // style={{
            //   zIndex: "20",
            //   marginLeft: "-10px",
            //   marginBottom: "30px",
            //   display: "flex",
            // }}
          >
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
              value={multiselect3}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Zone"
              //     : data.region == ""
              //     ? "without selected Region you can't select Zone"
              //     : "Search"
              // }
            />
          </div>

          <div className="col-sm-2">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            >
              {/* State Name */}
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
                defaultValue={
                  state.StateManagementOverallCall.OndutyReuquestRange1 == ""
                    ? []
                    : [
                        new Date(
                          state.StateManagementOverallCall.OndutyReuquestRange1
                        ),
                        new Date(
                          state.StateManagementOverallCall.OndutyReuquestRange2
                        ),
                      ]
                }
                onOpen={() => {
                  openMe()
                }}
             onClose={() => {
                CloseDateRange()
                   }}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  // if (e != null) {
                  //   setrange([]);
                  //   e.forEach((newValue) => {
                  //     var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                  //     var localISOTime = new Date(newValue - tzoffset)
                  //       .toISOString()
                  //       .slice(0, -1);
                  //     // "validtill",
                  //     handlechangedate(localISOTime);
                  //   });
                  // }

                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    // if (diffDays === 30) {
                    //   // Since we are using inclusive range, difference should be 30 for 31 days
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else if (diffDays < 30) {
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else {
                    //   toast.error("Please select a range of exactly 31 days.", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //   });
                    // }
                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                position: "relative",
                top: "95px",
                width: "92%",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <div style={{ width: "314px" }}></div>
              <div
                class=" field-div"
                style={{
                  position: "relative",
                  top: "-16px",
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                  zIndex: "1",
                  width: "351px",
                }}
              >
                <label
                  for="validationCustom02"
                  class="form-label"
                  style={{ fontSize: "15px" }}
                >
                  Employee Role
                </label>

                <Select
                  className="Selects"
                  styles={{ position: "relative", top: "60px" }}
                  onChange={(e) => {
                    HandleEMprole(e);
                  }}
                  value={EMpROleSelected}
                  options={EmpRoles}
                  placeholder="search"
                />
              </div>
            </div> */}

            <ReactTable
              data={state.OndutyCalls.OnDutyDatas}
              columns={column}
              totalItems={state.OndutyCalls.Total_counts}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={state.OndutyCalls.Total_counts}
              // Oncreate={(e) => setRoleCreatePopup(true)}
              values={state.StateManagementOverallCall.OndtyStatusState}
              options={options}
              Filter={Filter}
              count={count}
              ClearState={ClearState}
              placeHold={place}
              ///--- emoloyee role based filters -
              EmployeeRoleTrue={true}
              EmployeeRoleOption={EmpRoles}
              EMpROleSelected={state.StateManagementOverallCall.OndutyEmployeedesignation}
              HandleEMprole={HandleEMprole}
              ApproveRequestFilter={true}

            />
          </div>
        ) : null}
      </div>

      {EmployeePop && EmployeeIDs != undefined ? (
        <OnDutyEdit
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={currentPage}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          data={data}
          white_collar={filterForWhite.white_collar}
          // Datestate={Datestate}
          from_date={range[0]}
          to_date={range[1]}
          search={search}
        />
      ) : null}
      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
        />
      ) : null}
    </>
  );
};

export default Onduty;
